import { observer } from "mobx-react-lite";
import { VirtualizedItemList } from "@/components/item-list";
import { CollectionsListPageListEmpty } from "@/pages/collections/components/collections-list-page-list-empty";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";

export const CollectionsListPageList = observer(() => {
  const page = useTabPageStore("collectionsListPage");
  page.listState.useListStateEffects();

  if (page.shouldShowEmptyState) {
    return <CollectionsListPageListEmpty />;
  }

  return (
    <>
      <VirtualizedItemList
        enableArrowHighlightNavigation={true}
        onOpenHighlightedItem={({ itemId, event }) => {
          if (!page.orderedItemIds.includes(itemId)) {
            return;
          }

          page.store.navigation.goToCollection({ collectionId: itemId, event });
        }}
        rows={page.itemRows}
        listState={page.listState}
        loading={page.isLoading}
      />
      {page.listState.multiSelectUi}
    </>
  );
});
